import { gql } from '@apollo/client'
import React from 'react'

import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { usePermalinkToken } from '../../../../utils/session/permalinkToken'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useServiceOrder = () => React.useContext(Context)?.serviceOrder

const QUERY = gql`
  query ServiceOrder($id: ID, $permalinkToken: String) {
    serviceOrder(id: $id, permalinkToken: $permalinkToken, filter: { includeDeleted: true, ignoreSegments: true }) {
      id
      yearlyId
      endDate
      place {
        id
        name
        fieldValues {
          id
          value
          field {
            id
            name
          }
        }
      }
      replies {
        id
        value
        questionId
        blockIndex
      }
    }
  }
`

const ServiceOrderLoader = ({ children, id }) => {
  const permalinkToken = usePermalinkToken()
  const { data, ...state } = useQuery(QUERY, {
    variables: { id, permalinkToken },
    client: serviceOrdersClient
  })

  return (
    <StatePresenter {...state} empty={!data?.serviceOrder}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default ServiceOrderLoader
